/*#########################################################
    注文情報関連
#########################################################*/

module.exports = {
    // イベント呼び出し
    event(order_id = null, hash = null) {
        let formdata = new FormData();
        formdata.append('hash', hash);
        api({
            api: '/api/user/order/' + order_id,
            _method: "GET",
            formdata,
            callback: order.event_confirm,
            // e_callback: order.destroy_e_callback,
        });
    },
    // イベントの確認
    event_confirm(data) {
        const order = data.data;
        // モーダルを表示
        const title = "館名・スペースNo.の編集";
        const body = `
            <form id="form">
                <div id="errors"></div>
                <div class="mb-4">
                    <div>
                        <span class="h3 strong text-primary">館名・スペースNo.</span>
                        <span class="badge bg-danger">必須</span>
                    </div>
                    <div class="input-group">
                        <span class="input-group-text">館名</span>
                        <input type="text" class="form-control text-center" placeholder="西１" name="building_num" value="${order.building_num ?? ''}">
                        <span class="input-group-text">スペースNo</span>
                        <input type="text" class="form-control text-center" placeholder="Ｈ" name="space_num_01" value="${order.space_num_01 ?? ''}">
                        <input type="text" class="form-control text-center" placeholder="０１ａ" name="space_num_02" value="${order.space_num_02 ?? ''}">
                    </div>
                </div>
                <div class="mb-4">
                    <div>
                        <span class="h3 strong text-primary">本のタイトル</span>
                        <span class="badge bg-danger">必須</span>
                    </div>
                    <input type="text" id="name" class="form-control block mt-1 w-full" name="title"  value="${order.title ?? ''}" />
                    <small class="ms-3"><i class="fas fa-exclamation-triangle"></i> 納品時に必要となります・最大全角２０文字まで</small>
                </div>
                <div class="mb-4">
                    <div>
                        <span class="h3 strong text-primary">サークル名</span>
                        <span class="badge bg-danger">必須</span>
                    </div>
                    <input type="text" id="name" class="form-control block mt-1 w-full" name="circle_name"  value="${order.circle_name ?? ''}" />
                    <small class="ms-3"><i class="fas fa-exclamation-triangle"></i> 納品時に必要となります・最大全角２０文字まで</small>
                </div>
                <input type="hidden" name="id"  value="${order.id ?? ''}" />
                <input type="hidden" name="hash"  value="${order.hash ?? ''}" />
            </form>
        `;
        const footer = `
            <button type="button" class="btn btn-primary" onclick="order.event_save();">保存  <i class="fas fa-check-circle"></i></button>
        `;
        make_modal({ title, body, footer });
    },
    // イベントの保存
    event_save() {
        const form = document.getElementById('form');
        const formdata = new FormData(form);
        api({
            api: '/api/user/order/' + formdata.get('id'),
            _method: "PUT",
            formdata,
            callback: order.event_save_callback,
            e_callback: order.event_save_e_callback,
        });
    },
    event_save_callback(data) {
        const $targets = document.querySelector('[data-hash="' + data.data.hash + '"]').querySelectorAll('[data-name]');
        $targets.forEach($target => {
            $target.innerHTML = getValueFromObject(data.data, $target.dataset.name);
        });
        close_modal();
    },
    event_save_e_callback(data) {
        const $form = document.getElementById('form');
        const $errors = $form.querySelector('#errors');
        const errors = data.messageText.replace(/\n/g, '<br>');
        $errors.innerHTML = `
            <div class="alert alert-danger mb-4" role="alert">
                ${errors}
            </div>
        `;
    },

    // キャンセルの確認
    destroy_confirm(order_id = null, hash = null) {
        const title = "注文キャンセル";
        const body = "この注文をキャンセルしますか？";
        const footer = `
            <button type="button" class="btn btn-danger" onclick="order.destroy('${order_id}','${hash}')">ご注文のキャンセル  <i class="fas fa-times-circle"></i></button>
        `;
        make_modal({ title, body, footer });
    },
    // キャンセル確定
    destroy(order_id = null, hash = null) {
        let formdata = new FormData();
        formdata.append('hash', hash);
        api({
            api: '/api/user/order/' + order_id,
            _method: "DELETE",
            formdata,
            callback: order.destroy_callback,
            e_callback: order.destroy_e_callback,
        });
    },
    destroy_callback(data) {
        // 削除成功
        close_modal();
        // トーストを表示
        make_toast(data.toasts);
        const elm = document.querySelector('[data-hash="' + data.data.hash + '"]');
        let collapse = new bootstrap.Collapse(elm, {});
        collapse.hide();
    },
    destroy_e_callback(data) {
        // 削除失敗
        close_modal();
        // トーストを表示
        make_toast(data.toasts);
    }
}

